import { useState } from "react";
import logger from "@/lib/logging/logger";
import { urlShortenerApi } from "@/services";

export default function useUrlShortener() {
	const [shortUrl, setShortUrl] = useState<string>();

	const getShortUrl = async (url: string) => {
		try {
			const urls = await urlShortenerApi.createShortUrl(url);
			setShortUrl(urls.short_url);
		} catch (error) {
			logger.warning("INFO", "An error occurred calling urlShortener", error);
			setShortUrl(url);
		}
	};

	return {
		shortUrl,
		getShortUrl,
	};
}
